import { FormControl } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers";
import { getFieldError, getFieldPath, useOptionalLabel } from "@shared";
import { FormikValues, getIn } from "formik";

import { FormikTimePickerProps } from "./FormikTimePicker.types";

export function FormikTimePicker<T extends FormikValues>(props: FormikTimePickerProps<T>) {
  const {
    fieldName,
    path,
    formControlProps,
    formik,
    helperText,
    textFieldProps,
    label,
    disabled,
    required,
    optional,
    clearable,
    onValueChange,
    ...others
  } = props;

  const fullPath = getFieldPath(path, fieldName);
  const resolvedLabel = useOptionalLabel(label, optional);
  return (
    <FormControl fullWidth {...formControlProps}>
      <TimePicker
        label={resolvedLabel}
        name={fullPath}
        value={(getIn(formik.values, fullPath) as Date | null | undefined) ?? null}
        onChange={(value: Date | null) => {
          void formik.setFieldValue(fullPath, value, false);
          onValueChange?.(value);
        }}
        disabled={disabled}
        slotProps={{
          field: { clearable: true },
          textField: {
            required,
            variant: "outlined",
            size: "small",
            ...textFieldProps,
            error: !!getFieldError(formik, fullPath),
            helperText: getFieldError(formik, fullPath) ?? helperText,
            inputProps: { required: false },
            InputLabelProps: {
              sx: { fontSize: "0.875rem" },
              required,
            },
            InputProps: {
              sx: {
                paddingLeft: 0,
                "& .MuiPickersSectionList-root": {
                  minHeight: "40px",
                  lineHeight: "24px",
                  padding: "8px 14px",
                  fontSize: "0.875rem",
                  alignItems: "center",
                },
              },
            },
          },
        }}
        {...others}
      />
    </FormControl>
  );
}

export default FormikTimePicker;
